<template>
  <div class="cards-slider">
    <h2 v-if="title" class="typo-heading-h2 text-content-default mb-5">
      {{ title }}
    </h2>

    <div class="wrapper">
      <slot />
    </div>

    <UButton
      v-if="allButton"
      class="w-full mt-5"
      trailing-icon="i-local-move-up-right"
      variant="outline"
      :to="allButton?.to"
    >
      {{ allButton?.label }}
    </UButton>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: 'CardsSlider',
})

withDefaults(
  defineProps<{
    title?: string
    allButton?: {
      label: string
      to: string
    }
  }>(),
  {},
)
</script>

<style lang="scss" scoped>
.wrapper {
  display: grid;
  grid-template-rows: repeat(2, auto);
  grid-auto-columns: calc((100% - (2 * 8px) - 4px) / 2.05);
  grid-auto-flow: column;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 10px;

  &:has(> :nth-child(-n + 4):last-child) {
    grid-auto-columns: calc((100% - 8px) / 2);
    overflow-x: hidden;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  @include max-md {
    grid-auto-columns: 100%;

    &:has(> :nth-child(-n + 4):last-child) {
      grid-auto-columns: 100%;
    }
  }
}
</style>
